/**
 * Shared member-count formatting for tribes & forums.
 *
 * Fixes the global pluralization bug ("1 members") by choosing member/members
 * based on the count, and formats large counts as "1.2k". Use this everywhere a
 * member count is rendered so the behaviour stays consistent.
 *
 *   formatMemberCount(1)    → "1 member"
 *   formatMemberCount(5)    → "5 members"
 *   formatMemberCount(0)    → "0 members"
 *   formatMemberCount(1234) → "1.2k members"
 */
export function formatMemberCount(count?: number | null): string {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  const num = n >= 1000 ? `${(n / 1000).toFixed(1)}k` : `${n}`;
  return `${num} ${n === 1 ? 'member' : 'members'}`;
}
